

export const frontMatter = {
	title: 'API',
	sidebar_position: 1,
	description: 'Full reference for the Paneview API: methods and events for controlling the pane layout.'
};
export const contentTitle = undefined;
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-paneview-api-mdx-8a3.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [{
  "value": "See also",
  "id": "see-also",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "PaneviewApi"
      }), " is the primary interface for controlling a Paneview instance: adding and moving panes, saving and restoring layouts, and subscribing to events."]
    }), "\n", _jsx(DocRef, {
      declaration: "PaneviewApi"
    }), "\n", _jsx(_components.h2, {
      id: "see-also",
      children: "See also"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/other/paneview/overview",
          children: "Paneview overview"
        }), ": concepts and a live example of the pane view."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

